import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Stack } from '@components/stack';

import { useStore } from 'models/Provider';

export const UserModal = observer(({ title, children }) => {
  const { jobStore } = useStore();

  useEffect(() => {
    jobStore.loadForUserAccess();
  }, [jobStore]);

  return (
    <CreateUserWrapper>
      <Stack space={6}>
        <h2 data-cy="add-user-modal-header">{title}</h2>
        {children}
      </Stack>
    </CreateUserWrapper>
  );
});

const CreateUserWrapper = styled.div`
  background-color: #ffffff;
  height: 100%;
  margin: 0 auto;
  max-width: 380px;
  > div {
    flex-grow: 1;
  }
  @media (max-width: 480px) {
    padding: 10px 0;
  }
`;
